<template lang="pug">
	fieldset.search-range-input(v-click-outside="hideInputs" ref="root")
		.search-range-input__container.label-container(v-if="!isInputVisible", @click="showInputsAndFocus")
			span {{label}}
			span.search-range-input__postfix
				slot(name="postfix")
		.search-range-input__container(v-else)
			label.sr-only(:for="`${id}-range-from-input`")
			input.search-range-input__field(:id="`${id}-range-from-input`", placeholder="min", ref="firstInput", type="number", v-model.number="min", @focus="setBoxShadow", @blur="onFirstInputBlur", @keydown.tab.shift="onFirstInputShiftTab")
			spanonFirstInputhShiftTab.hyphen -
			label.sr-only(:for="`${id}-range-to-input`")
			input.search-range-input__field(:id="`${id}-range-to-input`", placeholder="max", ref="secondInput", type="number", v-model.number="max", @blur="onSecondInputBlur" @focus="setBoxShadow", @keydown.tab="onSecondInputTab")
			.search-range-input__postfix
				slot(name="postfix")
</template>
<script>
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import isMobile from '../../../common/js/is-mobile/is-mobile';
import vClickOutside from 'v-click-outside';
import * as R from 'ramda';
import label from '../libs/range-label';
const isBlank = R.either(R.isNil, R.isEmpty);
const FOCUS_CSS_CLASS = 'search-range-input--has-focus';
export default {
	mixins: [isMobile],
	directives: {
		clickOutside: vClickOutside.directive
	},
	data: () => ({
		isInputVisible: false,
		min: null,
		max: null
	}),
	props: {
		value: {
			required: true
		},
		id: {
			required: true,
			type: String
		},
		legend: {
			required: true,
			type: String
		}
	},
	watch: {
		value: {
			handler(val) {
				if (val && !isBlank(val.min)) {
					this.min = val.min;
				}
				if (val && !isBlank(val.max)) {
					this.max = val.max;
				}
			},
			immediate: true
		},
		min() {
			this.emitData();
		},
		max() {
			this.emitData();
		}
	},
	components: {
		VueSelect,
		VueSelectOption
	},
	computed: {
		label() {
			return label({ min: this.min, max: this.max, legend: this.legend });
		}
	},
	methods: {
		onFirstInputBlur() {
			setTimeout(() => {
				if (this.$refs.secondInput != document.activeElement) {
					this.hideInputs();
				}
			});
		},
		onFirstInputShiftTab() {
			this.$emit('first-input-shift-tab');
		},
		onSecondInputBlur() {
			setTimeout(() => {
				if (this.$refs.firstInput != document.activeElement) {
					this.hideInputs();
				}
			});
		},
		onSecondInputTab(e) {
			if (!e.shiftKey) {
				this.$emit('second-input-tab');
			}
		},
		emitData() {
			this.$emit('input', { min: this.min, max: this.max });
		},
		showInputsAndFocus() {
			this.showInputs();
			this.focusFirst();
		},
		showInputs() {
			this.isInputVisible = true;
		},
		async focusFirst() {
			await this.$nextTick();
			this.$refs.firstInput.focus();
		},
		hideInputs(e) {
			this.removeBoxShadow();
			this.isInputVisible = false;
		},
		setBoxShadow() {
			this.$refs.root.classList.add(FOCUS_CSS_CLASS);
		},
		removeBoxShadow() {
			this.$refs.root.classList.remove(FOCUS_CSS_CLASS);
		}
	}
};
</script>
<style lang="css" scoped>
@import '../../../common/variables.pcss';

.search-range-input {
	background: var(--white);
	border: 1px solid var(--grey-c5);
	margin: 0;
	height: 44px;
	line-height: 20px;
	padding: 0;
	color: var(--text-primary);
	display: block;
	transition: 0.2s;

	@media (--desktop) {
		margin-left: -1px;
		width: 145px;
	}

	&:first-child {
		border-radius: 4px;
		margin-bottom: 8px;

		@media (--desktop) {
			border-radius: 0;
			margin-bottom: 0;
		}
	}

	&:last-child {
		border-radius: 4px;

		@media (--desktop) {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}
	}
}

.search-range-input--has-focus {
	box-shadow: 0px 2px 0px 0px rgba(63, 81, 181, 1);
}

.search-range-input__container {
	align-items: center;
	display: flex;
	justify-content: space-between;
	height: 100%;
	padding: 10px;
}

.hyphen {
	margin: 0 10px;

	@media (--desktop) {
		margin: 0;
	}
}

.label-container {
	cursor: text;
}

.search-range-input__postfix {
	color: #a4a4a4;
}

.search-range-input__field + .search-range-input__postfix {
	display: none;

	@media (--desktop) {
		display: block;
	}
}

input {
	background: transparent;
	margin: 0;
	padding: 0;
	border: 0;
	height: 42px;
	color: var(--text-primary);
	font-family: 'regular', Arial, sans-serif;
	width: 100%;
	-moz-appearance: textfield;

	@media (--desktop) {
		width: 44px;
	}

	&:focus {
		outline: none;
	}
}

.size-input .search-range-input__postfix {
	transform: translateY(-3px);
}
</style>
